
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { GetAllZootRows, resetGetAllStatus } from "./slice"

export function ZootecniaList() {
    const dispatch = useAppDispatch()
    const livestockState = useAppSelector(state => state.notificationLivestock)
    const notificationState = useAppSelector(state => state.notification)

    useEffect(() => {
        dispatch(GetAllZootRows({ itemsPerPage: 0, page: 0, notificationId: notificationState.notificationIdToUpdate }))
    }, [])

    useEffect(() => {
        if (livestockState.getAllZootRowsStatus === 'successfully') {
            dispatch(resetGetAllStatus())
        }
    }, [livestockState.getAllZootRowsStatus])

    return (
        <div style={{ padding: '24px' }}>
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}></th>
                        <th className="width-[130px]">N. UP</th>
                        <th className="width-[130px]">Cod. ASL</th>
                        <th className="width-[100px]">Gruppo Allevamento</th>
                        <th className="width-[130px]">Specie Animale</th>
                        <th className="width-[130px]">Tipo Produzione</th>
                        <th className="width-[130px]">Consistenza</th>
                        <th className="width-[130px]">UBA</th>
                        <th className="width-[130px]">Metodo</th>
                        <th style={{ borderTopRightRadius: '8px', width: '40px' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        livestockState.getAllZootRows?.data.map((z, index) =>
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td></td>
                                <td>{z.productiveUnitNumber}</td>
                                <td>{z.aslCode}</td>
                                <td>{z.livestockGroup}</td>
                                <td>{z.animalSpecies}</td>
                                <td>{z.productionType}</td>
                                <td>{z.consistency}</td>
                                <td>{z.uba}</td>
                                <td>{z.method}</td>
                                <td></td>
                            </tr>
                        )}
                </tbody>
            </table>
        </div>
    )
}